module.exports = __webpack_public_path__ + "static/media/bannerModulE_small.62c661a7.jpg";